var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-content',[_c('div',{staticClass:"inner"},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("REGEXY")]),_c('templates',{attrs:{"regexType":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }